module.exports = __webpack_public_path__ + "static/media/revieve-logo.0da1ad19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instore/revieve-logo.svg
// module id = 121
// module chunks = 0